import React from 'react';

const LOGOS = [
  { src: '/images/openai.png', alt: 'OpenAI', mobileHeight: '3.6rem', desktopHeight: '4rem', featured: true },
  { src: '/images/salesforce.svg', alt: 'Salesforce', mobileHeight: '3.25rem', desktopHeight: '4rem' },
  { src: '/images/databricks.png', alt: 'Databricks', mobileHeight: '3rem', desktopHeight: '4rem' },
  { src: '/images/deloitte.svg', alt: 'Deloitte', mobileHeight: '2.05rem', desktopHeight: '2rem' },
  { src: '/images/access.png', alt: 'Access', mobileHeight: '6.375rem', desktopHeight: '6.75rem' },
  { src: '/images/ukgov.png', alt: 'UK Government', mobileHeight: '2.4rem', desktopHeight: '4rem' },
  { src: '/images/cmu.png', alt: 'CMU', mobileHeight: '3.1rem', desktopHeight: '4rem' },
];

const BuiltBy = () => (
  <div id="builtby">
    <div className="content pb-20 lg:py-[68px] max-sm:bg-white">
      <h4 className="flex text-black font-semibold sm:text-lg">
        Built by a team with deep HR, compliance, and engineering experience
      </h4>
      <div className="pt-6 md:pt-10 fade-up">
        <div className="builtby-logo-grid">
          {LOGOS.map((logo) => (
            <span
              key={logo.alt}
              className={`builtby-logo-item${logo.featured ? ' builtby-logo-item-featured' : ''}`}
              style={{
                '--mobile-logo-height': logo.mobileHeight,
                '--desktop-logo-height': logo.desktopHeight,
              }}
            >
              <img src={logo.src} alt={logo.alt} className="builtby-logo-image" />
            </span>
          ))}
        </div>
      </div>
      <div className="flex justify-center pt-10">
        <a
          className="font-medium flex flex-row items-center gap-1 hoverable-black group"
          href="https://sophare.ai/about"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Meet the team</span>
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            className="inline-block transition-transform duration-200 ease-out group-hover:translate-x-1"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="48"
              d="m268 112 144 144-144 144m124-144H100"
            ></path>
          </svg>
        </a>
      </div>
    </div>
  </div>
);

export default BuiltBy;
